var _defs, _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicrosoftPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eeeded;}.cls-2{fill:#999;}.cls-3{fill:#b7b6b6;}.cls-4{fill:#d31900;}.cls-5{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.5 0.3 42.5 255.69 191.48 255.69 255.32 191.85 255.32 0.3 42.5 0.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.48 191.36 191.48 255.69 255.32 191.36 191.48 191.36"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.48,
    y: 48.85,
    width: 138.87,
    height: 10.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.48,
    y: 76.28,
    width: 138.87,
    height: 10.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.48,
    y: 103.71,
    width: 138.87,
    height: 10.95
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.48,
    y: 131.14,
    width: 138.87,
    height: 10.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.91,55.5v145h145V55.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.84,140.75c-1.88-3.61-6.43-5.36-13.92-5.36A92.36,92.36,0,0,0,101.29,137c-8.52-9-17.33-21.91-23.61-34.69.72-3,1.32-5.7,1.82-8.23a101.63,101.63,0,0,0,1.75-11.56c.34-4,.35-8.21-1.84-11.87-.5-.84-3.15-5-6.27-5a23.57,23.57,0,0,0-4.88.81c-3.09,1-4.53,3.52-5.53,5.83C59.35,80.1,64,93.41,68.6,103.24a306.82,306.82,0,0,1-17.66,49.49c-17.82,8.08-27.29,16.06-28.16,23.71-.32,2.83.35,7,5.37,10.72a8,8,0,0,0,4.75,1.57c4.23,0,8.47-3.15,13.33-9.91a130.53,130.53,0,0,0,11.16-19.63,227.38,227.38,0,0,1,41-13c7.42,7,14.1,10.56,19.87,10.56A12.85,12.85,0,0,0,129,151.13C131.79,147.25,132.41,143.75,130.84,140.75ZM69.09,81.08a12.21,12.21,0,0,1,2.39-6.25c.93,1,3.75,5.85.32,13.81A9.77,9.77,0,0,1,69.09,81.08Zm22.49,58A236.32,236.32,0,0,0,62.42,148a329.93,329.93,0,0,0,12-33.51A159.68,159.68,0,0,0,91.58,139Zm31.33,5.59a7.86,7.86,0,0,1-.92,1.55c-.91,1.26-2.72,1.89-5.39,1.89-1.74,0-2.63-.73-4.6-2.35-.52-.42-1.08-.89-1.75-1.41a70,70,0,0,1,7.59-.4C121.31,143.91,122.35,144.33,122.91,144.63ZM33.06,180.15c-1.87-1.46-1.76-2.4-1.72-2.76.25-2.26,3.86-6.52,13.13-11.83C37.76,177.52,34,179.77,33.06,180.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrosoftPdf);
export default __webpack_public_path__ + "static/media/icon-microsoft-pdf.a36c3793.svg";
export { ForwardRef as ReactComponent };